// extracted by mini-css-extract-plugin
export default {"genre":"SlideCard_genre__SYb3Z","title":"SlideCard_title__irSFm","slide_card_contents":"SlideCard_slide_card_contents__A6IOE","overlay":"SlideCard_overlay__Du8i9"};